/** Форматируем и возвращаем строковое значение числа по разрядности */
export const formatDigitOrder = (value: string | number): string => value.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
